<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.storeList.push"
  >
    <v-column-time sortable=""/>
    <v-column-time value="删除时间" field="del_time"/>

    <el-table-column label="门店 ID" width="80" prop="id"/>
    <v-column-avatar label="门店名称" avatar-key="cover" nickname-key="store_name"/>
    <el-table-column label="地址">
      <template v-slot="{ row }">
        <span>{{ row.address }}</span>
      </template>
    </el-table-column>
    <el-table-column label="每月成本（元）" width="150">
      <template v-slot="{ row }">
        <span>{{ row.cost | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="每月房租（元）" width="150">
      <template v-slot="{ row }">
        <span>{{ row.rent | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="收入分成比例" width="150">
      <template v-slot="{ row }">
        <span>{{ `${row.revenue_sharing}%` }}</span>
      </template>
    </el-table-column>
    <el-table-column label="前台提成比例" width="150">
      <template v-slot="{ row }">
        <span>{{ `${row.receptionist_percentage}%` }}</span>
      </template>
    </el-table-column>
    <el-table-column label="未完成任务底薪比例" width="150">
      <template v-slot="{ row }">
        <span>{{ `${row.unfinished_rate}%` }}</span>
      </template>
    </el-table-column>
    <el-table-column label="企业微信标签 ID" width="150">
      <template v-slot="{ row }">
        <span>{{ row.we_chat_tag_id }}</span>
      </template>
    </el-table-column>
    <el-table-column label="课卡全国通用" width="150">
      <template v-slot="{ row }">
        <span>{{ row.is_generic ? '是' : '否' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="是否开启业绩任务" width="150">
      <template v-slot="{ row }">
        <span>{{ row.task_enabled ? '已开启' : '未开启' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="操作" width="300">
      <template v-slot="{ row }">
        <v-list-button name="修改门店" size="large" :to="RouteConfig.storeEdit.to(row.id)"/>

        <v-list-button
            icon="bin"
            name="恢复门店"
            @click="handleDelete(row)"
            :is-loading="isDeleting[row.id]"
            message="确认要恢复该门店吗？"
            size="large"
        />
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`store-deleted-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.del_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>门店</span>
              <v-avatar-nickname
                :value="v.cover"
                :nickname="v.store_name"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>门店 ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>地址</span>
              <span>{{ v.address }}</span>
            </div>
            <div class="list-item-detail">
              <span>每月成本</span>
              <span>{{ v.cost | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>每月房租</span>
              <span>{{ v.rent | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>收入分成比例</span>
              <span>{{ `${v.revenue_sharing}%` }}</span>
            </div>
            <div class="list-item-detail">
              <span>前台提成比例</span>
              <span>{{ `${v.receptionist_percentage}%` }}</span>
            </div>
            <div class="list-item-detail">
              <span>未完成任务底薪比例</span>
              <span>{{ `${v.unfinished_rate}%` }}</span>
            </div>
            <div class="list-item-detail">
              <span>企业微信标签 ID</span>
              <span>{{ v.we_chat_tag_id }}</span>
            </div>
            <div class="list-item-detail">
              <span>课卡全国通用</span>
              <span>{{ v.is_generic ? '是' : '否' }}</span>
            </div>
            <div class="list-item-detail">
              <span>是否开启业绩任务</span>
              <span>{{ v.task_enabled ? '已开启' : '未开启' }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button name="修改门店" size="large" :to="RouteConfig.storeEdit.to(v.id)"/>
              <v-list-button
                icon="bin"
                name="恢复门店"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="确认要恢复该门店吗？"
                size="large"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { index, restore } from '@/api/store';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.storeList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    queryList: {},
    isLoading: false,
    isDeleting: false,
  }),
  computed: {
    isAdministrator() {
      return this.$store.getters.isAdministrator;
    },
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      const { ...params } = queryList;
      params.is_del = 1;

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id }) {
      if (this.isDeleting) return;

      this.isDeleting = true;
      const { isError } = await restore(id);
      this.isDeleting = false;

      if (!isError) this.load();
    },
  },
};
</script>
